module.exports = __webpack_public_path__ + "img/archi2@2x.0aa2fc18.png";